import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { WalkAroundVideoComponent, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, photoCaptureUpdateContextDataAction, photoCaptureResetContextAction, photoCaptureFileUploadFailedAction, photoCaptureAttachmentDataAction, getPhotoCaptureIsTermsAndConditionAccepted, getPhotoCaptureAttachmentInfo, getPhotoCaptureContextId, getPhotoCaptureVideoSizeLimit, getPhotoCaptureQuestionnaireId, getPhotoCaptureAssignmentSubType, getPhotoCaptureAssignmentType, photoCaptureIsFileUploadStartedAction, getPhotoCaptureDisableLibrary, photoCaptureUpdateAttachedArtifactIdSuccessAction, getPhotoCaptureAttachedArtifactIds, getShouldShowCommentBox, getShouldAllowMitchellIntelligent } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction, getQuestionnaireEvaluationParentQuestionId, getQuestionnaireEvaluationAnswerDisplayText, getQuestionnaireEvaluationAnswered, getQuestionnaireEvaluationOptionalQuestion } from "../../../domain/questionnaireEvaluation";
import { getGPCEvaluationDocId } from '../utilities';
import { getGPCTheme, getGPCAttachmentsFromQuestionnaireEvaluation } from '../selectors';
const mapStateToProps = (state, ownProps) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        attachments: getGPCAttachmentsFromQuestionnaireEvaluation(state),
        contextId: getPhotoCaptureContextId(state),
        videoSizeLimit: getPhotoCaptureVideoSizeLimit(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        assignmentSubType: getPhotoCaptureAssignmentSubType(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state),
        parentQuestionId: getQuestionnaireEvaluationParentQuestionId(state),
        attachedArtifactIds: getPhotoCaptureAttachedArtifactIds(state),
        shouldShowCommentBox: getShouldShowCommentBox(state),
        isMic: getShouldAllowMitchellIntelligent(state),
        isOptionalQuestion: getQuestionnaireEvaluationOptionalQuestion(state),
        answerDisplayText: getQuestionnaireEvaluationAnswerDisplayText(state),
        isAnswered: getQuestionnaireEvaluationAnswered(state)
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    questionnaireEvaluationQuestionGetAction,
    questionnaireEvaluationSaveRequestAction,
    photoCaptureUpdateContextDataAction,
    photoCaptureAttachmentDataAction,
    photoCaptureResetContextAction,
    photoCaptureFileUploadFailedAction,
    photoCaptureIsFileUploadStartedAction,
    photoCaptureUpdateAttachedArtifactIdSuccessAction
}, dispatch);
const WalkAroundVideoComponentWrapper = (props) => React.createElement(WalkAroundVideoComponent, Object.assign({}, props));
export const ConnectedWalkAroundVideoComponent = connect(mapStateToProps, mapDispatchToProps)(WalkAroundVideoComponentWrapper);
//# sourceMappingURL=ConnectedWalkAroundVideoComponent.js.map